module.exports = __webpack_public_path__ + "assets/datadog.a6a79f19.svg";